import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * useInflation — Phase 7 (Jun 2026)
 *
 * Tiny shared hook returning the latest CPI / Core CPI / PCE
 * snapshot with computed YoY % values. Powers Real Yield tiles on
 * both the Stock Modal and the Portfolio macro strip.
 *
 * Process-lifetime cache (CPI publishes monthly; refetching on
 * every render is wasteful).
 */
let _cachedInflation = null;
let _inflight = null;

export function useInflation() {
  const [snap, setSnap] = useState(_cachedInflation);

  useEffect(() => {
    if (_cachedInflation) return undefined;
    if (!_inflight) {
      _inflight = axios
        .get(`${API}/macro/inflation`, { withCredentials: true })
        .then((r) => { _cachedInflation = r.data || null; return _cachedInflation; })
        .catch(() => { _cachedInflation = null; return null; })
        .finally(() => { _inflight = null; });
    }
    let cancelled = false;
    _inflight.then((s) => { if (!cancelled) setSnap(s); });
    return () => { cancelled = true; };
  }, []);

  return snap;
}
